import { RequestedAnswerItem } from "types/Models/chatQnA";
import { AnsweredQuestionCard } from "./AnsweredQuestionCard";

export const AllAnsweredQuestions = ({
  responses,
  showHeader = true,
}: {
  responses: RequestedAnswerItem[];
  showHeader?: boolean;
}) => (
  <div className="t-flex t-flex-col t-h-full t-overflow-hidden">
    {showHeader && (
      <div className="t-flex t-items-center t-px-4 t-border-0 t-border-b t-border-solid t-border-neutral-10 t-shrink-0 t-h-12">
        <span className="t-text-subtext t-font-medium t-text-text-100">
          Questions
        </span>
      </div>
    )}

    <div className="t-flex t-flex-col t-gap-2.5 t-p-4 t-min-h-0 t-flex-1 t-overflow-y-auto">
      {responses.map((response, index) => (
        <AnsweredQuestionCard
          key={response.uuid}
          number={index + 1}
          response={response}
        />
      ))}
    </div>
  </div>
);
